import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { Patient } from "@/Common/Models/Patient/Patient";
import { BcCareConnectAction } from "@/Patient/Components/MedicalNote/Actions/BcCareConnectAction";
import { BcCareConnectDomain } from "@/Patient/Models/BcCareConnect/BcCareConnect";

interface IBcCareConnectButtonProps {
    patient: Patient;
    domain: BcCareConnectDomain;
}

class BcCareConnectButton extends BaseReactComponent<IBcCareConnectButtonProps> {
    private action: BcCareConnectAction;

    public constructor(props: IBcCareConnectButtonProps) {
        super(props);
        this.action = new BcCareConnectAction();
    }

    public render(): JSX.Element {
        return (
            <ButtonControl
                variant="brand"
                onClick={(e: { target: any }) => {
                    e.target.blur();
                    this.openCareConnect();
                }}
                label="CareConnect"
            />
        );
    }

    private openCareConnect(): void {
        const { patient, domain } = this.props;
        this.action.CareConnect(patient, domain);
    }
}

export { BcCareConnectButton };
